"use client";
import CardFeedClient from "./CardFeedClient";

export default function HomePage(){
  return <CardFeedClient />;
}
